/**
 * Renderer Constants
 */

export const RENDERER = {
  COLS: 80,
  ROWS: 30,
  CELL_WIDTH_PX: 9,
  CELL_HEIGHT_PX: 16,
  MAX_PENDING_OPERATIONS: 100,
} as const;

export const SCALING = {
  BASE_ASSEMBLY_WIDTH: 800,
  BASE_ASSEMBLY_HEIGHT: 690,
  ASSEMBLY_MARGIN: 20,
  MIN_SCALE_FACTOR: 0.5,
  SCALE_PRECISION: 2, // round to nearest 0.5
} as const;

export const FONT_ATLAS = {
  GRID_WIDTH: 16,
  GRID_HEIGHT: 16,
  TOTAL_CHARS: 256,
  FONT_SIZE_OFFSET: 4,
  X_OFFSET: 1,
  Y_OFFSET: 2,
  DEFAULT_CHAR_INDEX: 32, // space
} as const;

export const CURSOR = {
  ALPHA: 0.7,
  BLINK_INTERVAL_MS: 500,
} as const;

export const TYPEWRITER = {
  DELAY_MS: 8,
  BATCH_SIZE: 3,
} as const;

export const SCROLL = {
  DETECTION_THRESHOLD_ROWS: 3,
} as const;

export const PIXEL_MODE = {
  WIDTH: 320,
  HEIGHT: 200,
  RGBA_BYTES_PER_PIXEL: 4,
  ALPHA_MAX: 255,
} as const;

export const HYBRID = {
  TERMINAL_COLS: 80,
  TERMINAL_ROWS: 30,
} as const;
